import { createContext } from 'react';

export const rightButtonVisibleContext = createContext<boolean>(false);
